<template>
  <el-form :model="competencia" ref="competencia" label-position="right" label-width="200px" v-loading="isLoading">
    <el-form-item label="Meta">
      <el-col :span="5">
        <el-input-number v-model="competencia.meta" :min="0"></el-input-number>
      </el-col>
    </el-form-item>
    <el-form-item label="Receber Respostas">
      <el-col :span="5">
        <el-switch
          v-model="competencia.seed_status"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-col>
    </el-form-item>
    <el-form-item label="Visivel">
      <el-col :span="5">
        <el-switch
          v-model="competencia.visivel"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-col>
    </el-form-item>
    <el-form-item label="Periodo Respostas">
      <el-col :span="5">
        <el-date-picker
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="Data Inicio"
          v-model="competencia.seed_inicio"
          style="width: 100%;"></el-date-picker>
      </el-col>
      <el-col class="line text-center" :span="1">
        <span>-</span>
      </el-col>
      <el-col :span="5">
        <el-date-picker
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="Data Fim"
          v-model="competencia.seed_fim"
          style="width: 100%;"></el-date-picker>
      </el-col>
    </el-form-item>
    <el-form-item >
      <el-button size="mini" type="primary" @click="onSubmit">Salvar</el-button>
      <el-button size="mini" type="danger" @click="onToggleState">{{ isOpen ? 'Fechar' : 'Abrir' }}</el-button>
    </el-form-item>
  </el-form>

</template>

<script>
  import {Notification} from 'element-ui'
  import {trataErrors , competenciaIsOpen } from '@/domain/utils'
  export default {
    name: "competencia-config",
    props:[ 'competencia'],
    data() {
      return {
        isLoading : false
      }
    },
    computed: {
      isOpen()
      {
        return competenciaIsOpen(this.competencia.status)
      }
    },
    methods: {
      async onSubmit() {
        try {
          let obj  = _.pick(this.competencia, ['seed_inicio', 'seed_fim', 'visivel', 'seed_status', 'meta' , 'id'])
          this.isLoading = true
          const {data} = await axios.put(`${process.env.API_PATH}/competencia/${obj.id}`, obj)
          Notification.success("Competencia Atualizada")

        } catch (error) {
          console.log(error)
          const {response} = error
          const message = response.status === 402 ? response.data.msg : "Erro interno, contate o suporte."
          Notification.error(message)
        }finally {
          this.isLoading = false
        }
      },
      async onToggleState(){
        try {
          this.isLoading = true
          const {data } = await axios.put(`${process.env.API_PATH}/competencia/${this.competencia.id}/togglestate`)
          this.$emit('competenciaChange')
        }catch (error) {
          trataErrors(error)
        }finally {
          this.isLoading = false
        }
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Competencia/CompetenciaConfig.vue